
import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { useNavigate } from "react-router";

import { Grid, Button, IconButton, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Typography, Dialog, DialogActions, DialogContent, FormControl, TextField, InputAdornment, OutlinedInput, CircularProgress, InputLabel, MenuItem, Select, Paper, InputBase, ButtonGroup, Autocomplete, Card, CardContent, CardHeader, Checkbox, Divider, Chip, FormGroup, FormControlLabel } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from '@mui/icons-material/Undo';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import SearchIcon from "@mui/icons-material/Search";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckIcon from '@mui/icons-material/Check';

import moment from "moment";

import { Layout } from "../../components/Layout"

import { TablePaginationActions } from "../../helpers/TablePaginationActions";
import { ObtenerDescripcionEntidad } from "../../helpers/ObtenerClaveEntidad";

import { openSnackbar } from "../../store/slices/SnackbarSlice";

import { usePages } from "../../hooks/usePages";
import { useFilter } from "../../hooks/useFilter";

import { SearchTextField } from "../../components/SearchTextField";

import { TableTheadStyle, TablePaddingStyle } from "../../styles/TableStyle";
import { InputSearchButtonsStyle, InputSearchStyle } from "../../styles/FormStyle";
import { DialogActionsStyle, DialogContentStyle } from "../../styles/DialogStyle";

import { ActualizarUsuario, AgregarUsuario, BuscarUsuarioRH, BuscarUsuariosDelegados, Usuarios } from "../../connections/admin/UsuarioConnection";
import { ObtenerTipoUsuarios } from "../../connections/catalogos/TipoUsuarioConnection";
import { ObtenerPuestos } from "../../connections/catalogos/PuestoConnection";
import { ObtenerRoles } from "../../connections/catalogos/RolConnection";

import { ActualizarAgregarUsuarioParams, RolUsuarioProps, UsuarioDelegadoProps, UsuarioProps } from "../../interfaces/admin/UsuarioInterface";
import { TipoUsuarioProps } from "../../interfaces/catalogos/TipoUsuarioInterface";
import { PuestoProps } from "../../interfaces/catalogos/PuestoInterface";

type ActionType = 'Nuevo' | 'Buscar';

export const UsuariosPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [openModal, setOpenModal] = useState( false );
    const [showPassword, setShowPassword] = useState(false);

    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );
    const [loadingBuscar, setLoadingBuscar] = useState( false );

    const [idUsuario, setIdUsuario] = useState( 0 );
    const [usuarios, setUsuarios] = useState<UsuarioProps[]>( [] );

    const [nombres, setNombres] = useState( '' );
    const [apellido1, setApellido1] = useState( '' );
    const [apellido2, setApellido2] = useState( '' );
    const [correoElectronico, setCorreoElectronico] = useState( '' );
    const [contrasena, setContrasena] = useState( '' );
    const [curp, setCurp] = useState( '' );
    
    const [tipoUsuario, setTipoUsuario] = useState( 0 );
    const [tipoUsuarioArray, setTipoUsuarioArray] = useState<TipoUsuarioProps[]>( [] );

    const [curpBuscar, setCurpBuscar] = useState( '' );
    const [action, setAction] = useState<ActionType>( 'Buscar' );
    
    const [puesto, setPuesto] = useState(0);
    const [puestoArray, setPuestoArray] = useState<PuestoProps[]>( [] );

    const [idUsuarioFirmaElectronica, setIdUsuarioFirmaElectronica] = useState(0);
    const [contrasenaFirmaElectronica, setContrasenaFirmaElectronica] = useState( '' );
    const [fechaExpiracionFirmaElectronica, setFechaExpiracionFirmaElectronica] = useState( '' );
    const [viewContrasenaFirma, setViewContrasenaFirma] = useState( false );

    const [idUsuarioSistemaTurnos, setIdUsuarioSistemaTurnos] = useState(0);

    const [roles, setRoles] = useState<RolUsuarioProps[]>( [] );
    const [rolesSelected, setRolesSelected] = useState<RolUsuarioProps[]>( [] );

    const [usuarioDelegado, setUsuarioDelegado] = useState( 0 );
    const [usuariosDelegados, setUsuariosDelegados] = useState<UsuarioDelegadoProps[]>( [] );

    const [activo, setActivo] = useState( true );
    const [restablecerContrasena, setRestablecerContrasena] = useState( false );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 5 );

    const { filtro, setFiltro, dataFiltrada } = useFilter( usuarios, ( item, filtro ) => {

        const nombreCompleto = `${ item.nombres } ${ item.apellido1 } ${ item.apellido2 ?? '' }`.toLowerCase();

        return nombreCompleto.includes( filtro.toLowerCase() );
    });

    const CURPFechaNacimiento = ( curp: string ) => {
        
        var m = curp.match( /^\w{4}(\w{2})(\w{2})(\w{2})/ ) ?? [];
        
        var anyo = parseInt(m[1],10) + 1900;
        
        if( anyo < 1950 ) anyo += 100;

        var mes = parseInt(m[2], 10)-1;
        var dia = parseInt(m[3], 10);

        return (new Date( anyo, mes, dia ));
    }

    const handleGuardar = async () => {

        if( idUsuario !== 0 ){

            const usuarioSelected = usuarios.find( ( elem ) => elem.idUsuario === idUsuario );

            if( usuarioSelected ){

                setLoading( true );

                const entidad = curp ? ObtenerDescripcionEntidad( curp.substring(11, 13) )?.estado : '';
                const fechaNacimiento = CURPFechaNacimiento( curp );
                const sexo = curp.substring(10, 11);

                const usuarioUpdate: ActualizarAgregarUsuarioParams = {
                    idUsuario: idUsuario,
                    nombres,               
                    apellido1,
                    apellido2,
                    correoElectronico,
                    contrasena,
                    idTipoUsuario: tipoUsuario,
                    curp,           
                    idUsuarioFirmaElectronica: idUsuarioFirmaElectronica ?? 0,
                    contrasenaFirmaElectronica,
                    fechaExpiracionFirmaElectronica,
                    idPuesto: puesto,
                    idUsuarioDelegado: usuarioDelegado,
                    roles: rolesSelected.map( ({ id }) => id ),
                    entidadNacimiento: entidad,
                    fechaNacimiento: moment( fechaNacimiento).format('YYYY-MM-DD'),
                    idSexo: sexo === 'H' ? 1 : 2,
                    activo,
                    restablecerContrasena,
                    idUsuarioSistemaTurnos: idUsuarioSistemaTurnos ?? 0,
                };    
    
                await ActualizarUsuario( usuarioUpdate ).then( resp => {
                    
                    const { success, message } = resp;

                    if( success ){

                        if( idUsuario ){

                            setTimeout(() => {
                                
                                const newArray = usuarios.map( item => {
                                    if( item.idUsuario === resp.idUsuario ){
                                        item = {
                                            ...resp
                                        };
                                    }
                                    return item;
                                });
                               
                                setUsuarios( newArray );
                                setOpenModal( false );
                                setShowPassword( false );
                                setLoading( false );
                                
                                dispatch( openSnackbar({ message: message, variant: 'success' }));   
                                
                            }, 700);
        
                        }  
                    }
                    else {
                        
                        dispatch( openSnackbar({ message: message, variant: 'error' }));   
                        setLoading( false );

                    }                      
        
                });

            }       

        }
        else {

            const entidad = curp ? ObtenerDescripcionEntidad( curp.substring(11, 13) )?.estado : '';
            const fechaNacimiento = CURPFechaNacimiento( curp );
            const sexo = curp.substring(10, 11);

            const usuarioAdd: ActualizarAgregarUsuarioParams = {
                idUsuario: idUsuario,
                nombres,               
                apellido1,
                apellido2,
                correoElectronico,
                contrasena,
                idTipoUsuario: tipoUsuario,
                curp,           
                idUsuarioFirmaElectronica: idUsuarioFirmaElectronica ?? 0,
                contrasenaFirmaElectronica,
                fechaExpiracionFirmaElectronica,
                idPuesto: puesto,
                idUsuarioDelegado: usuarioDelegado,
                roles: rolesSelected.map( ({ id }) => id ),
                entidadNacimiento: entidad,
                fechaNacimiento: moment( fechaNacimiento).format('YYYY-MM-DD'),
                idSexo: sexo === 'H' ? 1 : 2,
                activo,
                restablecerContrasena,
                idUsuarioSistemaTurnos: idUsuarioSistemaTurnos ?? 0,
            };    

            setLoading( true );

            await AgregarUsuario( usuarioAdd ).then( resp => {

                const { success, message } = resp;

                if( success ){                                
                
                    setTimeout(() => {
                        
                        setUsuarios([ ...usuarios, resp ]);
                        setOpenModal( false );
                        setShowPassword( false );
                        setLoading( false );

                        dispatch( openSnackbar({ message: message, variant: 'success' }));   

                    }, 700);
                       
                }
                else {
                    
                    dispatch( openSnackbar({ message: message, variant: 'error' }));   
                    setLoading( false );

                }  
    
            });

        }

    }

    const handleClose = () => {

        setIdUsuario( 0 );
        setCurpBuscar('');
        setCurp('');
        setNombres( '' );
        setApellido1( '' );
        setApellido2( '' )
        setCorreoElectronico( '' )
        setContrasena( '' );
        setCurp( '' );
        setTipoUsuario( 0 );
        setPuesto( 0 );

        setShowPassword( false );
        setViewContrasenaFirma( false );

        setIdUsuarioFirmaElectronica( 0 );
        setContrasenaFirmaElectronica( '' );
        setFechaExpiracionFirmaElectronica( '' );
        setUsuarioDelegado( 0 );
        setIdUsuarioSistemaTurnos( 0 );

        setActivo( true );
        setRestablecerContrasena( true );

        setRolesSelected( [] );
    }

    const handleBuscarUsuario = async () => {

        if( curpBuscar === '' ){
            return false;
        }        

        setLoadingBuscar( true );

        await BuscarUsuarioRH( curpBuscar ).then( resp => {

            if( resp ){               

                const { success, nombres, apellido_Primero, apellido_Segundo, email, curp } = resp;

                if( success ){                        
                    
                    setTimeout(() => {

                        setCurp( curp ?? '' );
                        setNombres( nombres ?? '' );
                        setApellido1( apellido_Primero ?? '' );
                        setApellido2( apellido_Segundo ?? '' );
                        setCorreoElectronico( email ?? '' );
                
                        setCurpBuscar('');

                        setLoadingBuscar( false );

                    }, 100);
                }
                else{                        

                    setCurp( '' );
                    setNombres( '' );
                    setApellido1( '' );
                    setApellido2( '' );
                    setCorreoElectronico( '' );
                    
                    setLoadingBuscar( false );

                    dispatch( openSnackbar({ message: `No se encontro la persona con el CURP: ${ curpBuscar }`, variant: 'error' }));   
                }

            }            

        });
        
    }

    const handleEditUsuario = ( { idUsuario, curp, nombres, apellido1, apellido2, correoElectronico, contrasena, idTipoUsuario, idPuesto, roles, idUsuarioFirmaElectronica, contrasenaFirmaElectronica, fechaExpiracionFirmaElectronica, idUsuarioDelegado, activo, restablecerContrasena, idUsuarioSistemaTurnos }: UsuarioProps ) => {

        setIdUsuario( idUsuario );

        setCurp(curp ?? "");
        setNombres( nombres );
        setApellido1( apellido1 );
        setApellido2( apellido2  ?? "")
        setCorreoElectronico( correoElectronico )
        setContrasena( contrasena );
        setTipoUsuario( idTipoUsuario );
        setPuesto( idPuesto );

        setIdUsuarioFirmaElectronica( idUsuarioFirmaElectronica );
        setContrasenaFirmaElectronica( contrasenaFirmaElectronica );
        setFechaExpiracionFirmaElectronica( fechaExpiracionFirmaElectronica );
        setUsuarioDelegado( idUsuarioDelegado );
        setIdUsuarioSistemaTurnos( idUsuarioSistemaTurnos );

        setActivo( activo );
        setRestablecerContrasena( restablecerContrasena );

        if( roles.length !== 0){

            const optionsDefault = roles.filter( ({ selected }) => { return selected === true; } );

            setRolesSelected( optionsDefault );

            setRoles( roles );
        }

        setOpenModal( true );

    }

    useEffect(() => {
      
        async function obtener(){

            setLoadingData( true );
            setUsuarios( [] );

            await Usuarios().then( resp => {

                setTimeout(() => {
                    
                    setUsuarios( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [ ])   

    useEffect(() => {
      
        async function obtener(){

            await ObtenerTipoUsuarios().then( resp => {

                setTimeout(() => {
                    
                    setTipoUsuarioArray( resp );

                }, 700);

            });           

        }

        obtener();

    }, [ ])   

    useEffect(() => {
        
        async function Obtener(){    

            await ObtenerPuestos().then( resp => {              
                setPuestoArray( resp );                 
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){     

            await BuscarUsuariosDelegados().then( resp => {
                setUsuariosDelegados( resp );    
            });
        }

        if( openModal ){
            Obtener();
        }

    }, [ openModal ]);

    useEffect(() => {
        
        async function Obtener(){     

            await ObtenerRoles().then( resp => {
                
                const rolesArray: RolUsuarioProps[] = resp.map( ( { idRol, descripcion } ) => {
                    return {
                        id: idRol,
                        descripcion,
                        selected: false,
                    }
                });

                setRoles( rolesArray );

            });
        }
       
        Obtener();        

    }, []);

    return (
        
        <Layout breadcrumbs={[ { text: 'Administración' }, { text: 'Usuarios' } ]} backgroundPaper={false} >

            <Grid container spacing={3} >  
                
                <Grid size={{ xs: 6 }} textAlign={'start'}>

                    <Button startIcon={ <UndoIcon /> } color="secondary" variant="text" sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }> 
                        Regresar
                    </Button> 

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={'end'}>

                    <Button 
                        variant="contained" 
                        sx={{ mt: 1 }} 
                        onClick={ () => {
                            handleClose();
                            setOpenModal( true );
                        }}
                    > 
                        Agregar
                    </Button> 

                </Grid>

            </Grid>

            <Grid container spacing={2} sx={{ mt: 2 }}>

                <Grid size={{ xs: 12 }} textAlign={'start'}>

                    <SearchTextField
                        value={ filtro }
                        label="Buscar por nombre del usuario"
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>   

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'5%' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'30%' }}> Nombre completo </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}> Correo electrónico </TableCell>   
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%' }}> Tipo de usuario </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}> Puesto </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%', textAlign: 'center' }}> Firma <br /> electrónica </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                ?
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                :
                                    dataFiltrada
                            )
                            .map( ( usuario, index ) => (

                                <TableRow key={ index } >
                                
                                    <TableCell sx={{ fontWeight: 'bold' }}>
                                        <Chip                                         
                                            label={ usuario.idUsuario }
                                            color={ usuario.activo ? 'primary' : 'error' }
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <Typography fontSize={14} fontWeight={'bold'}>{ usuario.nombres.toUpperCase() } { usuario.apellido1.toUpperCase() } { usuario.apellido2?.toUpperCase() }</Typography>
                                        <Typography fontSize={12} mt={1}>{ usuario.curp }</Typography>                              
                                    </TableCell>    

                                    <TableCell>
                                        { usuario.correoElectronico }
                                    </TableCell>      

                                    <TableCell>
                                        { usuario.tipoUsuario }
                                    </TableCell>                                        
                                    
                                    <TableCell>
                                        { usuario.puesto }
                                    </TableCell>                                        
                               
                                    <TableCell sx={{ textAlign: 'center' }}>

                                        { usuario.idUsuarioFirmaElectronica !== 0 && <Chip label={ <CheckIcon sx={{ mt: 1 }} /> } color="primary" variant="filled" sx={{ borderRadius: 3 }} /> }
                                  
                                    </TableCell>                                        
                                                  
                                    <TableCell>
                                        <IconButton 
                                                color="primary" 
                                                aria-label="edit" 
                                                component="span" 
                                                onClick={ () => handleEditUsuario( usuario ) }
                                            >                                                        
                                            <EditIcon />
                                        </IconButton>  
                                    </TableCell>

                                </TableRow>

                            ))
                        }                    

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?   
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={7} align="center"> 

                                        <Typography variant="caption" color='secondary'> No se encontraron resultados </Typography>
                                        
                                    </TableCell>

                                </TableRow>                     
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={7} align="center"> 

                                            <CircularProgress size={32} />
                                            
                                        </TableCell>

                                    </TableRow>                     
                        }
                        
                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&

                                <TableRow>

                                    <TableCell colSpan={2} sx={{ border: 'none'}}>
                                        <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                            Total de registros: { dataFiltrada.length }
                                        </Typography>
                                    </TableCell> 

                                    <TablePagination  
                                        sx={{ border: 'none'}}
                                        rowsPerPageOptions={[ 5, 10, 20, 50, 100 ]}
                                        colSpan={8}
                                        count={ dataFiltrada.length }
                                        rowsPerPage={ rowsPerPage }
                                        page={ page }          

                                        onPageChange={ handleChangePage }
                                        onRowsPerPageChange={ handleChangeRowsPerPage }

                                        ActionsComponent={ TablePaginationActions }

                                        labelRowsPerPage="Filas por página"                                            
                                        labelDisplayedRows={
                                            ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                            }
                                        }  
                                    />

                                </TableRow>

                            }

                    </TableFooter>
                    
                </Table>

            </TableContainer>

            <Dialog open={ openModal } fullWidth={true} maxWidth='lg'>
             
                <DialogContent sx={ DialogContentStyle }>      

                    <Grid container spacing={2}>

                        {
                            idUsuario === 0
                            &&
                                <Grid size={12}>

                                    <ButtonGroup
                                        disableElevation
                                        fullWidth
                                        size="small"
                                        variant="text"
                                    >
                                        <Button variant={ action === 'Buscar' ? "contained" : "outlined" } onClick={ () => setAction( 'Buscar' ) }>
                                            Buscar usuario en RRHH
                                        </Button>
                                        <Button variant={ action === 'Nuevo' ? "contained" : "outlined" } onClick={ () => setAction( 'Nuevo' ) }>
                                            Nuevo usuario
                                        </Button>
                                    </ButtonGroup>

                                </Grid>
                        }

                        {
                            ( idUsuario === 0 ) 
                            &&
                                <Grid size={12}> 

                                    <Paper
                                        component="div"
                                        sx={ InputSearchStyle }
                                    >
                                    
                                        <InputBase
                                            sx={{ ml: 1, flex: 1 }} 
                                            placeholder="Buscar usuario"
                                            inputProps={{ 'aria-label': 'Buscar usuario' }}
                                            value={ curpBuscar }
                                            onChange={ ( e ) => setCurpBuscar( e.target.value.toUpperCase() ) }
                                            disabled={ action === 'Nuevo' }
                                        />

                                        <Button 
                                            type="button" 
                                            variant='contained'                                  
                                            size='small'
                                            sx={ InputSearchButtonsStyle } 
                                            disabled={ curpBuscar.length < 18 }
                                            loading={ loadingBuscar }
                                            onClick={ handleBuscarUsuario }
                                        >
                                            <SearchIcon />
                                        </Button>      

                                    </Paper>      

                                </Grid>                      
                        }                    

                        <Grid size={{ xs: 12, md: 6 }}>

                            <Card>

                                <CardHeader sx={{ backgroundColor: (theme) => theme.palette.primary.main }} subheader={ <Typography sx={{ fontWeight: '400', color: 'white' }}> Información del usuario </Typography> }/>
                                
                                <Divider />
                            
                                <CardContent>

                                    <Grid container spacing={3}>                                        

                                        <Grid size={{ xs: 12, md: 12 }}>
                                         
                                            <TextField
                                                fullWidth
                                                label='Curp'
                                                placeholder="XXXX000000XXXXXX00"
                                                autoComplete="off"                             
                                                variant="outlined" 
                                                slotProps={{
                                                    input: {
                                                        autoComplete: 'off'
                                                    },
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}     
                                                value={ curp }           
                                                onChange={ (e) => setCurp( e.target.value ) }         
                                                disabled={ action === 'Buscar' && idUsuario === 0 }
                                            />

                                        </Grid>

                                        <Grid size={{ xs: 12, md: 12 }}>
                                           
                                            <TextField
                                                fullWidth
                                                label='Nombre(s)'
                                                placeholder="Juan"
                                                autoComplete="off"                             
                                                variant="outlined"   
                                                slotProps={{
                                                    input: {
                                                        autoComplete: 'off'
                                                    },
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}      
                                                value={ nombres }           
                                                onChange={ (e) => setNombres( e.target.value ) }
                                                disabled={ action === 'Buscar' && idUsuario === 0 }
                                            />

                                        </Grid>

                                        <Grid size={{ xs: 12, md: 6 }}>
                                            
                                            <TextField
                                                fullWidth
                                                label='Apellido 1'
                                                placeholder="Perez"
                                                autoComplete="off"                             
                                                variant="outlined"     
                                                slotProps={{
                                                    input: {
                                                        autoComplete: 'off'
                                                    },
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}       
                                                value={ apellido1 }           
                                                onChange={ (e) => setApellido1( e.target.value ) }  
                                                disabled={ action === 'Buscar' && idUsuario === 0 }        
                                            />

                                        </Grid>

                                        <Grid size={{ xs: 12, md: 6 }}>
                                        
                                            <TextField
                                                fullWidth
                                                label='Apellido 2'
                                                placeholder="Perez"
                                                autoComplete="off"                             
                                                variant="outlined"     
                                                slotProps={{
                                                    input: {
                                                        autoComplete: 'off'
                                                    },
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}    
                                                value={ apellido2 }           
                                                onChange={ (e) => setApellido2( e.target.value ) }      
                                                disabled={ action === 'Buscar' && idUsuario === 0 }    
                                            />

                                        </Grid>       

                                        <Grid size={{ xs: 12, md: 12 }}>

                                            <FormControl required fullWidth>
                                                
                                                <InputLabel>Puesto</InputLabel>
                                            
                                                <Select                                       
                                                    label="Puesto"
                                                    value={ puesto }
                                                    onChange={ ( e ) => { setPuesto( parseInt( e.target.value.toString() ) ); } }
                                                >
                                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                        
                                                    {
                                                        puestoArray.map( ( e ) => (
                                                            <MenuItem key={ e.idPuesto } value={ e.idPuesto }>{ e.descripcion }</MenuItem>                                                        
                                                        ))
                                                    }                     
                                                    
                                                </Select>

                                            </FormControl>

                                        </Grid>    

                                        <Grid size={{ xs: 12, md: 12 }}>

                                            <TextField
                                                fullWidth
                                                label='Correo electrónico'
                                                type="email"
                                                placeholder="persona@pjecz.gob.mx"
                                                autoComplete="off"                             
                                                variant="outlined"       
                                                slotProps={{
                                                    input: {
                                                        autoComplete: 'off'
                                                    },
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}    
                                                value={ correoElectronico }           
                                                onChange={ (e) => setCorreoElectronico( e.target.value ) }      
                                            />

                                        </Grid>                                                    
                                        
                                        {
                                            idUsuario !== 0
                                            &&
                                                <Grid size={{ xs: 12, md: 12 }}>

                                                    <FormControl variant="outlined" fullWidth>
                                                        <InputLabel shrink>Contraseña</InputLabel>
                                                        <OutlinedInput
                                                            notched
                                                            fullWidth
                                                            label="Contraseña"                                
                                                            placeholder="****************"                             
                                                            autoComplete="current-password"  
                                                            type={ showPassword ? 'text' : 'password' }
                                                            value={ contrasena }           
                                                            onChange={ (e) => setContrasena( e.target.value ) }
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        edge="end"
                                                                        size='small'
                                                                        aria-label={ showPassword ? 'hide the password' : 'display the password' }                                        
                                                                        onClick={ () => setShowPassword( ( show ) => !show ) }
                                                                    >
                                                                        { showPassword ? <VisibilityOffIcon /> : <VisibilityIcon /> }
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            }
                                                        />
                                                    </FormControl>

                                                </Grid>
                                        }   

                                    </Grid>

                                </CardContent>

                            </Card>

                        </Grid>    

                        <Grid size={{ xs: 12, md: 6 }}>

                            <Card>
                                <CardHeader sx={{ backgroundColor: (theme) => theme.palette.primary.main }} subheader={ <Typography sx={{ fontWeight: '400', color: 'white' }}> Configuración </Typography> }/>
                                
                                <Divider />
                            
                                <CardContent>

                                    <Grid container spacing={3}>                 
                                
                                        <Grid size={{ xs: 12, md: 6 }}>

                                            <FormControl required fullWidth>
                                                
                                                <InputLabel>Tipo de usuario</InputLabel>
                                            
                                                <Select                                                                                  
                                                    label="Tipo de usuario"
                                                    value={ tipoUsuario }
                                                    onChange={ ( e ) => { setTipoUsuario( parseInt( e.target.value.toString() ) ); } }
                                                >
                                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>                        
                                                    {
                                                        tipoUsuarioArray.map( ( e ) => (
                                                            <MenuItem key={ e.idTipoUsuario } value={ e.idTipoUsuario }>{ e.descripcion }</MenuItem>                                                        
                                                        ))
                                                    }                     
                                                    
                                                </Select>

                                            </FormControl>

                                        </Grid>      

                                        <Grid size={{ xs: 12, md: 6 }}>

                                            <TextField
                                                fullWidth
                                                label="ID Usuario Sistema Turnos"                                                     
                                                type="number"
                                                variant="outlined"             
                                                slotProps={{
                                                    input: {
                                                        autoComplete: 'off'
                                                    },
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}                                           
                                                value={ idUsuarioSistemaTurnos }                                
                                                onChange={ (e) => setIdUsuarioSistemaTurnos( parseInt( e.target.value.toString() ?? '0' ) ) }                              
                                            />

                                        </Grid>  

                                        <Grid size={{ xs: 12, md: 12 }}>

                                            <TextField
                                                fullWidth
                                                label="ID Usuario Firma Electrónica"                                             
                                                type="number"
                                                variant="outlined"             
                                                slotProps={{
                                                    input: {
                                                        autoComplete: 'off'
                                                    },
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}                                           
                                                value={ idUsuarioFirmaElectronica }                                
                                                onChange={ (e) => setIdUsuarioFirmaElectronica( parseInt( e.target.value.toString() ?? '0' ) ) }                              
                                            />

                                        </Grid>  

                                        <Grid size={{ xs: 12, md: 12 }}>
                                            
                                            <FormControl variant="outlined" fullWidth>
                                                <InputLabel shrink>Contraseña Firma Electrónica</InputLabel>
                                                <OutlinedInput  
                                                    notched
                                                    label="Contraseña Firma Electrónica"
                                                    name="contrasenaFirma"
                                                    placeholder="****************" 
                                                    type={ viewContrasenaFirma ? 'text' : 'password'}
                                                    value={ contrasenaFirmaElectronica }                                
                                                    onChange={ (e) => setContrasenaFirmaElectronica( e.target.value ) }
                                                    endAdornment={
                                                        <InputAdornment position="end">
                                                            <IconButton onClick={ () => setViewContrasenaFirma( (prev) => !prev ) } edge="end" >
                                                                {
                                                                    viewContrasenaFirma 
                                                                    ?
                                                                        <VisibilityOffIcon />
                                                                    :
                                                                        <VisibilityIcon />
                                                                }                                                    
                                                            </IconButton>
                                                        </InputAdornment>
                                                    }
                                                />
                                            </FormControl>

                                        </Grid>        

                                        <Grid size={{ xs: 12, md: 12 }}>

                                            <TextField
                                                fullWidth
                                                label="Fecha expiración de la Firma Electrónica"
                                                name="fechaExpiraFirma"                                
                                                type="date"
                                                variant="outlined"
                                                slotProps={{
                                                    input: {
                                                        autoComplete: 'off'
                                                    },
                                                    inputLabel: {
                                                        shrink: true,
                                                    }
                                                }}       
                                                value={ fechaExpiracionFirmaElectronica }                                
                                                onChange={ ( e ) => setFechaExpiracionFirmaElectronica( e.target.value ) }           
                                            />

                                        </Grid>                                

                                        <Grid size={{ xs: 12, md: 12 }}>    

                                            <FormControl fullWidth>
                                                <InputLabel>Delegar bandeja a:</InputLabel>
                                            
                                                <Select                                                                               
                                                    label="Delegar bandeja a:"
                                                    value={ usuarioDelegado }                                
                                                    onChange={ (e) => setUsuarioDelegado( e.target.value ) }
                                                >
                                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>
                                                    {
                                                        usuariosDelegados.map( ( { idUsuario, nombreCompleto } ) => (
                                                            <MenuItem key={idUsuario} value={idUsuario}>{ nombreCompleto }</MenuItem>
                                                        ))
                                                    }
                                                </Select>

                                            </FormControl> 

                                        </Grid>

                                        <Grid size={{ xs: 12, md: 6 }}>    

                                            <FormGroup>
                                                <FormControlLabel
                                                    control={ <Switch checked={ activo } onChange={ (e) => setActivo( e.target.checked ) } />}
                                                    label="Activar usuario"
                                                />
                                            </FormGroup>

                                        </Grid>

                                        <Grid size={{ xs: 12, md: 6 }}>    

                                            <FormGroup>
                                                <FormControlLabel
                                                    control={ <Switch checked={ restablecerContrasena } onChange={ (e) => setRestablecerContrasena( e.target.checked ) } />}
                                                    label="Restablecer contraseña"
                                                />
                                            </FormGroup>

                                        </Grid>

                                    </Grid>

                                </CardContent>

                            </Card>

                        </Grid>      

                        <Grid size={{ xs: 12, md: 12 }}>  

                            <Card>
                                <CardHeader sx={{ backgroundColor: (theme) => theme.palette.primary.main }} subheader={ <Typography sx={{ fontWeight: '400', color: 'white' }}> Permisos </Typography> }/>
                                
                                <Divider />
                            
                                <CardContent>
                                
                                    <Autocomplete                                            
                                        multiple
                                        id="select-roles"
                                        value={ rolesSelected }
                                        options={ roles } 
                                        onChange={ ( _, value ) => setRolesSelected( value ) }
                                        disableCloseOnSelect
                                        getOptionLabel={ (option) => option.descripcion}
                                        renderOption={ (props, option, { selected }) => (
                                            <li { ...props } key={ option.descripcion } >
                                                <Checkbox                                                     
                                                    icon={ <CheckBoxOutlineBlankIcon fontSize="small" /> }
                                                    checkedIcon={ <CheckBoxIcon fontSize="small" /> }
                                                    style={{ marginRight: 8 }}
                                                    checked={ selected }
                                                />
                                                { option.descripcion }
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField { ...params } label="Selecciona los permisos" placeholder=""  />
                                        )}
                                    />
                                    
                                </CardContent>

                            </Card>

                        </Grid>                 
                        
                    </Grid>     

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>

                    <Button 
                        color="secondary"
                        disabled={ loading } 
                        onClick={ () => { setOpenModal( false ); handleClose(); } }
                    > 
                        Cancelar 
                    </Button>

                    <Button 
                        loading={ loading } 
                        disabled={ 
                            tipoUsuario === 1
                            ?
                                idUsuario !== 0
                                ?
                                    curp === '' || nombres === '' || apellido1 === '' || correoElectronico === '' || contrasena === '' 
                                : 
                                    curp === '' || nombres === '' || apellido1 === '' || correoElectronico === ''
                            :
                                idUsuario !== 0
                                ?
                                    curp === '' || nombres === '' || apellido1 === '' || correoElectronico === '' || contrasena === '' || tipoUsuario === 0
                                : 
                                    curp === '' || nombres === '' || apellido1 === '' || correoElectronico === '' || tipoUsuario === 0
                        } 
                        variant='contained' 
                        onClick={ handleGuardar }
                    > 
                        Guardar 
                    </Button>

                </DialogActions>

            </Dialog>

        </Layout>
        
    )
}